import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';

export class CategoryService extends AuthenticatedService {
  public list = async (): Promise<IHttpResponse<string[]>> => {
    const categories = await this.getAuth<string[]>(
      'categories',
    );

    return categories;
  }

  public create = async (category: string): Promise<IHttpResponse<string>> => {
    const newCategory = await this.postAuth<string>(
      `categories/${category}`, undefined,
    );

    return newCategory;
  }

  public remove = async (category: string): Promise<IHttpResponse<string>> => {
    const newCategory = await this.deleteAuth<string>(
      `categories/${category}`, false,
    );

    return newCategory;
  }
}
